var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../../../../@common/styles/styles.scss";
import UsernamePopup from "./UsernamePopup";
import { useEffect, useState } from "react";
import React from "react";
import NOTIFICATION_LOGO from "../../../../assets/images/svg/bell-regular.svg";
import USER_LOGO from "../../../../assets/images/png/dummy-user.png";
import { isUserWithProfile } from "base-ui-generic/Common/Helpers/RoutesHelper";
import { NOTIFICATIONS_PAGE_URL } from "base-ui-generic/Common/Utils/RedirectURIs";
function LoggedInUserRibbon(props) {
    var login = props.login, handleClickLogout = props.handleClickLogout, isAdmin = props.isAdmin, onProfileClick = props.onProfileClick, dashboardUrl = props.dashboardUrl;
    var anchorEl = React.useRef(null);
    var _a = useState(false), isUsernamePopupVisible = _a[0], setUsernamePopupVisible = _a[1];
    var _b = useState(false), userWithProfile = _b[0], setUserWithProfile = _b[1];
    useEffect(function () {
        var res = isUserWithProfile();
        if (res) {
            setUserWithProfile(res);
        }
    }, []);
    var onClickLogout = function () {
        handleClickLogout();
    };
    var hideUsernamePopup = function () {
        if (isUsernamePopupVisible) {
            setUsernamePopupVisible(function (isUsernamePopupVisible) { return !isUsernamePopupVisible; });
        }
    };
    var onNotificationClick = function () {
        window.location.href = NOTIFICATIONS_PAGE_URL;
    };
    return (_jsx("div", __assign({ className: "modernization-header__wrapper__right__buttons", "data-testid": "logged-in-user-ribbon" }, { children: _jsxs("ul", __assign({ className: "modernization-header__nav clear" }, { children: [userWithProfile && !isAdmin && (_jsx("li", __assign({ className: "modernization-header__nav__notification modernization-login-block-with-image", onClick: onNotificationClick }, { children: _jsx("img", { src: NOTIFICATION_LOGO, alt: "" }) }))), _jsx("li", __assign({ className: "modernization-header__nav__user", "data-testid": "logged-in-user-ribbon-profile", onClick: function () {
                        return setUsernamePopupVisible(function (isUsernamePopupVisible) { return !isUsernamePopupVisible; });
                    } }, { children: _jsxs("div", __assign({ className: "modernization-header__nav__user__wrapper modernization-login-block-with-image", ref: anchorEl }, { children: [_jsx("img", { src: USER_LOGO, alt: "Profile" }), _jsx("span", { children: login })] })) })), _jsx(UsernamePopup, { dataTestid: "username-popup", open: isUsernamePopupVisible, handleLogout: onClickLogout, anchorEl: anchorEl.current, handleClose: hideUsernamePopup, isUserWithProfile: userWithProfile, isAdmin: isAdmin, onProfileClick: onProfileClick, dashboardUrl: dashboardUrl })] })) })));
}
export default LoggedInUserRibbon;
